import React from "react";
import WebQrScan from "./_webQrScan";
import WebCam from "./_webCam";
import ReactSketchCanvasComponent from "./_drawing";
class WebScan extends React.Component {
  ws = null;
  state = {
    focustCaptureBtn: 0,
    storedFiles: [],
    renderFiles: [],
    scanuse: false,
    clickStar: 0,
    openImg: {
      show: false,
      renderFiles: null,
      idx: -1
    },
    idQrScan: "",
    typeScan: [
      { value: "1", label: "POZ | Interní poznámka", prefix: "POZ_" },
      { value: "2", label: "CN | Cenový návrh", prefix: "CN_" },
      { value: "3", label: "VT | Výsledky testů", prefix: "VT_" },
      { value: "4", label: "SD | Skeny dokumentace", prefix: "SD_" },
      { value: "4", label: "SD-FA | Faktura dokumentace", prefix: "SDFA_" },
      { value: "5", label: "SP | Skeny poškození", prefix: "SP_" },
      { value: "6", label: "DOC | Dokumentace", prefix: "DOC_" },
      { value: "7", label: "SL | Servisní list", prefix: "SL_" },
      { value: "8", label: "FA | Faktura", prefix: "FA_" },
      { value: "9", label: "POS | Posudek", prefix: "POS_" },
      { value: "10", label: "SN | Sken SN", prefix: "SN_" },
      { value: "11", label: "CAL | Kalibrace", prefix: "CAL_" },
      { value: "12", label: "TPO | Test před opravou", prefix: "TPO_" },
      { value: "13", label: "IP | Interní poškození", prefix: "IP_" },
      { value: "14", label: "SHIP | Štítek dopravy", prefix: "SHIP_" },
      { value: "15", label: "WT | Water test", prefix: "WT_" },
      { value: "16", label: "API | API Dokument", prefix: "API_" },
      { value: "17", label: "NTF | Notifikace", prefix: "NTF_" },
      { value: "18", label: "ND | Informace k ND", prefix: "ND_" },
    ],
    typeScanSelect: JSON.parse(localStorage.getItem("webCamTypeSelect")),
  };

  SetWebCamImg = (e) => {
    var file = {
      content: e,
      filename:
        this.state.typeScanSelect.prefix + this.uuidv4().split("-")[0] + ".jpg",
      docType: this.state.typeScanSelect.value,
    };
    this.renderFiles(file);
  };

  uuidv4() {
    return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) =>
      (
        c ^
        (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))
      ).toString(16)
    );
  }

  componentDidMount() {
    try {
      this.ws = new WebSocket("ws://localhost:8181/");
      this.ws.onopen = (e) => {};
      this.setState({ idQrScan: this.uuidv4() });
    } catch (err) {}

    if (localStorage.getItem("webCamTypeSelect") == null) localStorage.setItem("webCamTypeSelect",JSON.stringify({
      value: "4",
      label: "SD | Skeny dokumentace",
      prefix: "SD_",
    }))
  }

  scan = () => {
    this.setState({ scanuse: true });
    if (this.ws.readyState !== 1) {
      this.props.setToast(
        "WebScan aplikace není spuštěna, nebo není nainstalována. WebScan aplikace je k dispozici ke stažení v sekci 'KE STAŽENÍ'.",
        "WebScan",
        "danger"
      );
      this.setState({ scanuse: false });
      return;
    }

    this.ws.send("SCAN_NOW");
  };

  barcode = () => {
    if (this.ws.readyState !== 1) {
      this.props.setToast(
        "WebScan aplikace není spuštěna, nebo není nainstalována. WebScan aplikace je k dispozici ke stažení v sekci 'KE STAŽENÍ'.",
        "WebScan",
        "danger"
      );
      this.setState({ scanuse: false });
      return;
    }
    this.ws.send("READ_BARCODE");
  };

  componentWillUnmount() {
    this.ws.close();
  }

  deleteFile(idx) {
    var renderFiles = this.props.files;
    renderFiles.splice(idx, 1);
    this.props.setFiles(renderFiles);
    this.setState({focustCaptureBtn: 1});
  }

  renderFiles(e) {
    var renderFiles = this.props.files;
    e.docType = this.state.typeScanSelect.value;
    e.filename =
      this.state.typeScanSelect.prefix + this.uuidv4().split("-")[0] + ".jpg";
    renderFiles.push(e);
    this.props.setFiles(renderFiles);
    this.setState({focustCaptureBtn: 1});
  }

  changeTypeFile(idx) {
    this.setState({focustCaptureBtn: 1});
    var renderFiles = this.props.files;
    renderFiles[idx].filename =
      this.state.typeScanSelect.prefix + this.uuidv4().split("-")[0] + ".jpg";
    renderFiles[idx].docType = this.state.typeScanSelect.value;
    this.props.setFiles(renderFiles);
  }

  editImgFile = (e,idx) => {
    this.setState({focustCaptureBtn: 1});
    var renderFiles = this.props.files;
    renderFiles[idx].content = e;
    this.props.setFiles(renderFiles);
  }

  render() {
    // eslint-disable-next-line no-lone-blocks
    {
      this.ws !== null &&
        (this.ws.onmessage = (e) => {
          var f = e.data;
          f.name =
            this.state.typeScanSelect.prefix +
            this.uuidv4().split("-")[0] +
            ".jpg";
          //f = {...f,docType: this.state.typeScanSelect.value};
          var storedFiles = this.state.storedFiles;
          storedFiles.push(f);

          var reader = new FileReader();
          reader.onload = (e) => {
            var file = {
              content: e.target.result,
              filename: f.name,
              docType: this.state.typeScanSelect.value,
            };
            this.renderFiles(file);
          };
          reader.readAsDataURL(f);
          this.setState({ scanuse: false });
        });
    }
    const {
      Bs,
      SIZE,
      VARIANT,
      Icon,
      docType,
      docTypeFilter,
      twain,
      mobile,
      webCam,
      files,
      onKeyDown
    } = this.props;

    return (
      <>
        {this.state.openImg.show && (
          <Bs
            modal
            show={this.state.openImg.show}
            onHide={() =>
              this.setState({ openImg: { show: false, renderFiles: null } })
            }
            keyboard={false}
            backdrop="static"
            centered
            size={SIZE.LG}
            aria-labelledby="contained-modal-title-vcenter"
          >
            <Bs modalheader closeButton>
              {this.state.openImg.renderFiles.filename}
            </Bs>
            <Bs modalbody>
              <ReactSketchCanvasComponent editImg={(e) => this.editImgFile(e,this.state.openImg.idx) } {...this.props} backgroundImage={this.state.openImg.renderFiles.content} />
            </Bs>
          </Bs>
        )}
        <Bs row>
          <Bs col xs={7}>
            <>
              {!docTypeFilter && (
                <>
                  <Bs formtext>Vyber typ scanu</Bs>
                  <Bs
                    brtxselect
                    isDisabled={!docType}
                    options={this.state.typeScan}
                    value={this.state.typeScanSelect}
                    onChange={(e) => {
                      this.setState({ typeScanSelect: e,focustCaptureBtn: 1});
                      //localStorage.setItem("webCamTypeSelect",JSON.stringify(e));
                    }}
                  />
                </>
              )}
              {docTypeFilter && (
                <>
                  <Bs formtext>Vyber typ scanu</Bs>
                  <Bs row className="ms-1 d-flex justify-content-start">
                  <Bs
                    brtxselect
                    isDisabled={!docType}
                    options={this.state.typeScan.filter(
                      (f) => docTypeFilter.indexOf(f.value) > -1
                    )}
                    value={this.state.typeScanSelect}
                    onChange={(e) => {
                      this.setState({ typeScanSelect: e,clickStar: 0 });
                    }}
                  />
                  {(this.state.typeScanSelect.prefix !== JSON.parse(localStorage.getItem("webCamTypeSelect")).prefix && this.state.clickStar === 0)  && (
                    <Icon fastar data-tip={"Nastavit jako oblíbený"} className="cursor-pointer" onClick={() => {
                      localStorage.setItem("webCamTypeSelect",JSON.stringify(this.state.typeScanSelect));
                      this.setState({ clickStar: 1 });
                    }}/>
                  )}
                  
                  </Bs>
                  
                </>
              )}
            </>
          </Bs>
          <Bs col xs={2} className="mt-4">
            {twain && (
              <Bs
                button
                disabled={this.state.scanuse || !twain}
                variant="success"
                size="sm"
                onClick={this.scan}
              >
                {this.state.scanuse ? <Bs brtxspin /> : "TWAIN"}
              </Bs>
            )}
          </Bs>
          <Bs col xs={3} className="mt-4">
            {mobile && (
              <WebQrScan SetImg={(e) => this.renderFiles(e)} {...this.props} />
            )}
          </Bs>
          <Bs row>
            <Bs col xs={12} className="mt-2">
              <Bs row>
                <Bs card bg={VARIANT.TRANSPARENT} className="d-flex">
                  <Bs row className="scanImg-btn-row">
                    <Bs span className="text-muted">
                      Počet nascenovaných obrázků: {files.length}
                    </Bs>
                    {files.map((e, idx) => (
                      <Bs col xs={4} lg={2}>
                        <Bs div className="scanImg-btn d-flex">
                          <Bs div>
                            <Bs
                              badge
                              pill
                              bg={VARIANT.DANGER}
                              className="scanImg-badge cursor-pointer"
                              data-tip="Smazat"
                              onClick={() => this.deleteFile(idx)}
                            >
                              <Bs span className="scanImg-badge-text">
                                x
                              </Bs>
                            </Bs>
                            <Bs
                              badge
                              pill
                              bg={VARIANT.LIGHT}
                              className="scanImg-text cursor-pointer"
                            >
                              <Bs span className="scanImg-badge-text">
                                <Bs strong className=" c-danger">
                                  {e?.filename?.split("_")[0]}
                                </Bs>
                              </Bs>
                            </Bs>

                            <Bs
                              image
                              className="scanImg cursor-pointer"
                              src={e.content}
                              data-tip={
                                "Zobrazit náhled (Zvětšit) " + e.filename
                              }
                              onClick={() => {
                                this.setState({
                                  openImg: { show: true, renderFiles: e, idx: idx },
                                });
                              }}
                            />
                            <Icon
                              faedit
                              data-tip={"Změnit typ dokumentu"}
                              className="c-white cursor-pointer me-2 scanImg-btn-icon"
                              onClick={() => this.changeTypeFile(idx)}
                            />
                          </Bs>
                        </Bs>
                      </Bs>
                    ))}
                  </Bs>
                </Bs>
              </Bs>
            </Bs>
          </Bs>
          <Bs row>
            <Bs col xs={12}>
              {webCam && (
                <WebCam
                  {...this.props}
                  returnImg={this.SetWebCamImg}
                  
                />
              )}
            </Bs>
          </Bs>
        </Bs>
      </>
    );
  }
}

export default WebScan;
